<!--
  ViewInternalDashboard.vue — REPLACES the current scaffold.
  Drop into web/src/views/ViewInternalDashboard.vue
  NOTE: not compile-verified (no Vue build) — Manish to test locally.
  Lists the internal dashboards the logged-in user may see (server decides), then
  renders the chosen one in a sandboxed iframe, injecting its data as
  window.__DASHBOARD_DATA__.payload (same convention as the client dashboards).
  Grid: a vs-table for reliability — swap to the project's AG grid if preferred.
-->
<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <!-- LIST -->
      <vx-card>
        <vs-row vs-w="12" class="mb-5">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12">
            <h3>Dashboards</h3>
          </vs-col>
        </vs-row>

        <vs-table :data="dashboards" v-if="dashboards.length">
        <ClientDataGrid :context="'InternalDashboardViewDataGrid'" ref="InternalDashboardViewDataGrid" :columnDefs="internalDashboardViewColumnDef" :rowData="dashboards">
        </ClientDataGrid>
        </vs-table>
        <div v-else class="text-center p-10">
          <p>You don't have any dashboards assigned yet.</p>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import defineAbilitiesFor from "@/config/abilities";
export default {
   created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
  },
  components: {
    ClientDataGrid
  },
  data() {
    return {
       internalDashboardViewColumnDef: [
        {
          headerName: "Name",
          field: "name",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          field: "description",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },


      ],
      internalDashboardViewComponentKey: 0,
      dashboards: [],
      selected: null,
      srcdoc: "",
      loadingFrame: false
    };
  },
  methods: {
    loadList() {
      let self = this;
      self.$vs.loading();
      axios
        .get(this.$base_url + "/api/internal_dashboard/my_internal_dashboards")
        .then(res => {
          self.dashboards = res.data || [];
          self.$vs.loading.close();
        })
        .catch(err => {
          self.$vs.loading.close();
          if (err.response && err.response.status === 401) this.$router.replace("/login");
        });
    },
    back() {
      this.selected = null;
      this.srcdoc = "";
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>

<style>
.internal_frame {
  width: 100%;
  height: 80vh;
  border: none;
}
</style>